import React from 'react';
import { formatToShortDateOrNull } from '~/util/date';
import { createQueryDataTable, type PropsOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import type { SieveFilterOperator } from '~/util/sieve/filter';

const NeedsAssignedScheduleReportDataTable = createQueryDataTable('schedule-report');
type TableProps = PropsOfQueryDataTable<typeof NeedsAssignedScheduleReportDataTable>;

const columnDefinitions = NeedsAssignedScheduleReportDataTable.columns([
	{
		header: 'Patient',
		key: 'patientName',
		sortable: true,
		renderCell: row => `${row.patientName} (MR#: ${row.patientCode})`
	},
	{
		header: 'Visit Date',
		key: 'visitDate',
		sortable: true,
		filterNames: ['visitDate', 'visitDateFrom', 'visitDateTo'],
		renderCell: row => formatToShortDateOrNull(row.visitDate, '-')
	},
	{
		header: 'Discipline',
		key: 'discipline',
		sortable: true
	},
	{
		header: 'Team',
		key: 'team',
		sortable: true
	}
]);

export function NeedsAssignedScheduleReportTable(props: TableProps) {
	const staticFilters = [...(props.staticFilters ?? []), { name: 'assigned', operator: '==' as SieveFilterOperator, value: false }];
	return (
		<NeedsAssignedScheduleReportDataTable.Table
			columns={columnDefinitions}
			emptyMessage="No visits need assigned"
			{...props}
			staticFilters={staticFilters}
		/>
	);
}
